import React ,{Component} from 'react';
import { Navigate  } from 'react-router-dom';
import axios from 'axios';

import Button from '@mui/material/Button';
import { styled } from '@mui/system';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
import TableSortLabel from '@mui/material/TableSortLabel';
import TablePagination from '@mui/material/TablePagination';
import TableBody from '@mui/material/TableBody'; 
import IconButton from '@mui/material/IconButton';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import ReactToPrint from 'react-to-print';
//import { styled } from '@mui/material/styles';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import Uploadfile from './Uploadfile';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import FlipCameraAndroidIcon from '@mui/icons-material/FlipCameraAndroid';		
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(100%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 100,
});


const useStyles = styled({   
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
  

  table: {
    minWidth: 750,
  },
  
});



function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}


function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}



export default class JournalViewmore extends Component {
	
    constructor(props) {
    super(props);
	
 this.state = {open:false, addopen: false,redirect:false,pagename:'',jo_id:'',prevfile:'',
	 JournalData:[],JournalLedgerData:[],journaldate:'',decription:'',finalcredit:'',finaldebit:'',
		
	}
	      
	}
	
	

	
	componentWillMount() { 
	
if(localStorage.getItem("ISIuserid")==null)
		 {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
	
	  this.JournalViewmore();
	

	  
	
	}
 getParameterByName(name, url) {
    if (!url) url = window.location.href;
    url = url.toLowerCase(); 
    name = name.replace(/[\[\]]/g, "\\$&").toLowerCase();
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}



JournalLedgetGetAll(joid){

	axios.get(localStorage.getItem("ISIurl")+'ajaxjournal.php?action=journaldetails&sorting=jr_id&jr_jo_id='+joid)
     
  .then(resp => {  	
    if(resp.data.length>0){
		
		this.setState({
			optionstaxRep:resp.data,
		},()=>{
			
			let grandcredit=0;
			let granddebit=0;
			this.state.optionstaxRep.forEach(eachrep => {
						grandcredit = parseFloat(grandcredit) + parseFloat(eachrep.jr_credit);
						granddebit = parseFloat(granddebit) + parseFloat(eachrep.jr_debit);
					},()=>{
						
						
						
					});
			this.setState({  
			  JournalLedgerData:resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			   finalcredit:grandcredit,
			   finaldebit:granddebit
			});
		})
		
		 
		
			

     }
	 
	  else{
		   this.setState({JournalLedgerData:[],totaldata:0});
	 }
	 
  
    });
}











JournalDelete= (e) =>{  

		let r = window.confirm("Do you really want to Delete?");
		 if(r === true){ 
				 var formData = new FormData(); 
					 
					
					 formData.append('action','delete')
		             formData.append('jo_id',this.state.jo_id)
					 formData.append('userid',localStorage.getItem("ISIuserid"))
				
					   axios.post(localStorage.getItem("ISIurl")+"ajaxjournal.php", formData, {
        }).then(res => {
						
											if(res.data === 1)
{ 
	
					this.setState({redirect:true,pagename:'/Adminjournals'});
}	
						
				
						})
		 }
 }





JournalViewmore() {
    let search = window.location.href;
    let Joid = this.getParameterByName('joid', search);

axios.get(localStorage.getItem("ISIurl")+'ajaxjournal.php?action=getall&jo_cmp_id='+localStorage.getItem("ISIcmpid")+'&jo_id='+Joid)
        .then(resp => {
            if (resp.data.length > 0) {
               let strname="Journal: "+resp.data[0].jo_reference;
		   
	 this.props.parentdasCallback(
            strname+"~"
        );
		   this.setState({
					 JournalData:resp.data,
					 jo_id:resp.data[0].jo_id,prevfile:resp.data[0].jo_file,
					 journaldate:resp.data[0].journalformatdate,
					 decription:resp.data[0].jo_description,
					 
                },()=>{
					
				});
				
				  this.JournalLedgetGetAll(Joid); 
            } else {
                this.setState({ JournalData:[]});
            }
        });
}



handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  }

 handlAddfileopen = () => {
        
  this.refs.Uploadfile.handleaddfileClose();
}


	render() {
		
		  if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
	
let totalcredit=0;
let totaldebit=0;
    return (
	
<React.Fragment>	
  <div className="estimateviewcontainer">
    <div className="estimateviewerleftbox">
 <div className="paddingbox">
 <div className="jornalbox">
      <Table>
	 <tr><td><p><b>Date</b></p></td> <td><p><b>Description</b></p></td></tr>
	 <tr><td>{this.state.journaldate}</td><td>{this.state.decription}</td></tr>
	 
	 </Table>
 
 </div>
  
 
 
        <div ref={el => (this.componentRef = el)} >
          <Paper>
            <TableContainer className="table-container">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell className="table-head" style={{"width":"30%"}} >Ledger Account</TableCell>
                      <TableCell className="table-head" style={{"width":"40%"}} >Details</TableCell>
                      <TableCell className="table-head" style={{"width":"15%"}} >Debit</TableCell>
                      <TableCell className="table-head" style={{"width":"15%"}} >Credit</TableCell>
                  </TableRow>
                </TableHead>
				
				

                <TableBody>
                  {this.state.JournalLedgerData.map((item, index) => {
                   
				   
                    return (
                      <React.Fragment key={index}>
                        <TableRow className="table-cell" style={{ backgroundColor: '#f1f5f6' }}>
                       
                          <TableCell className="table-cell">{item.le_code} - { item.le_displayname}</TableCell>
                          <TableCell className="table-cell">{ item.jr_details}</TableCell>
						  
<TableCell className="table-cell">
  {Number(item.jr_debit || 0).toFixed(2)}
</TableCell>

<TableCell className="table-cell">
  {Number(item.jr_credit || 0).toFixed(2)}
</TableCell>
						 
						  
                        </TableRow>
						
						
						
						
                      </React.Fragment>
                    );
                  })}
				  {this.state.JournalLedgerData.length!==0 &&(
                      <TableRow >
					<TableCell ></TableCell>

                          <TableCell><b>Total</b></TableCell>
			<TableCell><b>$ {Number(this.state.finaldebit || 0).toFixed(2)}</b></TableCell>
<TableCell><b>$ {Number(this.state.finalcredit || 0).toFixed(2)}</b></TableCell>
                          
                       
                         
                        </TableRow>
				  )}
				    
				  {this.state.JournalLedgerData.length===0 &&(
				  
                 <TableRow>
                 <TableCell  >
                  No Journal Details Found
                  </TableCell>
                </TableRow>

				  
				  
				  )}
				  
				  
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
       </div>
      </div>
    </div>

    <div className="estimateviewerightbox">
   
	  
	  
	  
	  <div className="invoiceupdatebox">
	  
		
		   <div className="Viewfunctionality">
            <ul>
             {this.state.sestatus!=="3" && (  <li>
            <p className="icon-text">
             <a href={'/#/Addjournals?joid='+this.state.jo_id} >  <EditOutlinedIcon className="verticalalign"/> &nbsp; Edit</a>
            </p>
             </li>)}
				 
			 {this.state.sestatus!=="3" && (  <li>
            <p className="icon-text" onClick={this.handlAddfileopen}>
            <AttachFileOutlinedIcon className="verticalalign"/> &nbsp; Add file
          </p>

             </li>)}
			   {this.state.prevfile!="" && (
		     <li><p className="icon-text" >
		  <AttachFileOutlinedIcon className="verticalalign"/> <a href={localStorage.getItem("ISIurl")+"uploads/"+this.state.prevfile} target="_blank">View File</a>
		 </p>  </li>)}
			 
           <li>
            <p className="icon-text"> <a href={'/#/Addjournals?joid='+this.state.jo_id+'&copy=1'} >
              <ContentCopyOutlinedIcon className="verticalalign"/>&nbsp; Copy</a>
            </p>
			</li>
			 
			<li>
            <p className="icon-text">
              <a  
	onClick={this.Deletesaleestimate}
               
                rel="noreferrer"  > <FlipCameraAndroidIcon className="verticalalign"/>&nbsp; Reverse</a>
            </p>
			</li>
			
			
			
		 	 <li>
            <p  onClick={()=>{this.refs.PrintBox.handleClickPrint();}}>
               <LocalPrintshopOutlinedIcon className="verticalalign" /> &nbsp; Print 
				
			
            </p>  
             </li>
			
			
           <li>
              <p onClick={this.JournalDelete}>
              <DeleteOutlineOutlinedIcon className="verticalalign"/>&nbsp; Delete
            </p>
			</li>
		 
			

      
		 
		 
		 
			 
		 
		 
             </ul>
			 <div className="clear"></div>
               </div>

	  </div>
	  
	  
	  
    </div>
  </div>

  <div className="clear"></div>
  

  <PrintBox ref="PrintBox" id={this.state.jo_id}  journaldate={this.state.journaldate} description={this.state.decription}
  
  finalcredit={this.state.finalcredit}
  finaldebit={this.state.finaldebit}
  
  />



  <div className="addfile">
	   <Uploadfile ref="Uploadfile" id={this.state.jo_id}  strrtype={6}/>
 
   </div>
  
</React.Fragment>
    );
}

}









export class PrintBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
	  journalRefernceArray:[],
    };
  }
  
  

 handleClickPrint = () => {
 
  this.GetJournalReferenceByid(this.props.id)
  
};


  handleClose = () => {
    this.setState({ printopen: false });
  };
  
  
  
  
  

  
  
 GetJournalReferenceByid(id){
	
axios.get(localStorage.getItem("ISIurl")+'ajaxjournal.php?action=journaldetails&jr_jo_id='+id)

  .then(resp => {  	
    if(resp.data.length>0){
		
			this.setState({  
			  journalRefernceArray:resp.data,  
			 	
			},()=>{
				 setTimeout(() =>
document.getElementById('print-button').click() 
,500);
				
			});

     }
	
	  else{
		   this.setState({journalRefernceArray:[]});
	 }
	 
  
    });
}

  
  

  render() {
	 
 return (
	
	 <React.Fragment>
	 <div className="printmod">
 <div ref={el => (this.componentRef = el)} >
 
 
       <div className="jornalbox">
			  <Table>
			 <tr><td><p><b>Date</b></p></td> <td><p><b>Description</b></p></td></tr>
			 <tr><td>{this.props.journaldate}</td><td>{this.props.decription}</td></tr>
			 
			 </Table>
 
       </div>
  
 
          <Paper>
            <TableContainer className="table-container">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell className="table-head" style={{"width":"30%"}} >Ledger Account</TableCell>
                      <TableCell className="table-head" style={{"width":"40%"}} >Details</TableCell>
                      <TableCell className="table-head" style={{"width":"15%"}} >Debit</TableCell>
                      <TableCell className="table-head" style={{"width":"15%"}} >Credit</TableCell>
                  </TableRow>
                </TableHead>
				
				

                <TableBody>
                  {this.state.journalRefernceArray.map((item, index) => {
                  
                    return (
                      <React.Fragment key={index}>
                        <TableRow className="table-cell" style={{ backgroundColor: '#f1f5f6' }}>
                       
                          <TableCell className="table-cell">{item.le_code} - { item.le_displayname}</TableCell>
                          <TableCell className="table-cell">{ item.jr_details}</TableCell>
						  
						 <TableCell className="table-cell">
  {Number(item.jr_debit || 0).toFixed(2)}
</TableCell>

<TableCell className="table-cell">
  {Number(item.jr_credit || 0).toFixed(2)}
</TableCell>
						 
						  
                        </TableRow>
						
                      </React.Fragment>
                    );
                  })}
				  
                      <TableRow >
					<TableCell ></TableCell>

                          <TableCell><b>Total</b></TableCell>
						  <TableCell><b>$ {this.props.finaldebit}</b></TableCell>
                          <TableCell ><b>${this.props.finalcredit}</b></TableCell>
                        </TableRow>
				  
				    
				  {this.state.journalRefernceArray.length===0 &&(
				  
                 <TableRow>
                 <TableCell  >
                  No Journal Details Found
                  </TableCell>
                </TableRow>

				  
				  
				  )}
				  
				  
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
       </div>
      
   

<ReactToPrint 
            trigger={() => <p id="print-button" className="Primarybuttons">Print </p>}
			content={() =>  this.componentRef} />
		</div>	
		
			 </React.Fragment>
	
 ) }
}
